/** Sidebar nav model — groups/items/counts mirror the design. */
import type { AppScreen } from './types';

export interface NavItem {
  label: string;
  screen: AppScreen;
  icon: string;
  count?: number;
}
export interface NavGroup {
  label: string;
  items: NavItem[];
}

export const NAV_GROUPS: NavGroup[] = [
  { label: 'Overview', items: [{ label: 'Dashboard', screen: 'dashboard', icon: 'dashboard' }] },
  {
    label: 'Sales',
    items: [
      { label: 'Quotes', screen: 'quotes', icon: 'quote' },
      { label: 'Invoices', screen: 'invoices', icon: 'fileText' },
      { label: 'Credit Notes', screen: 'credit-notes', icon: 'creditNote' },
      { label: 'Customers', screen: 'contacts', icon: 'building' },
      { label: 'Customer Statements', screen: 'statements', icon: 'file' },
    ],
  },
  {
    label: 'Purchases',
    items: [
      { label: 'Bills', screen: 'bills', icon: 'cart' },
      { label: 'Vendor Credits', screen: 'vendor-credits', icon: 'creditNote' },
      { label: 'Expenses', screen: 'expenses', icon: 'receipt' },
    ],
  },
  {
    label: 'Money',
    items: [
      { label: 'Payments', screen: 'payments', icon: 'wallet' },
      { label: 'Banking', screen: 'banking', icon: 'bank' },
    ],
  },
  {
    label: 'Journals',
    items: [
      { label: 'Manual Journals', screen: 'journals', icon: 'journal' },
    ],
  },
  {
    label: 'Accountant',
    items: [
      { label: 'Chart of Accounts', screen: 'coa', icon: 'book' },
      { label: 'Periods', screen: 'periods', icon: 'calendar' },
      { label: 'Reports', screen: 'reports', icon: 'chart' },
      { label: 'Migration', screen: 'migration', icon: 'refresh' },
    ],
  },
];

export const SCREEN_TITLES: Record<string, string> = {
  dashboard: 'Dashboard',
  quotes: 'Quotes',
  invoices: 'Invoices',
  'credit-notes': 'Credit Notes',
  contacts: 'Customers',
  statements: 'Customer Statements',
  bills: 'Bills',
  'vendor-credits': 'Vendor Credits',
  expenses: 'Expenses',
  payments: 'Payments',
  banking: 'Banking & Reconciliation',
  coa: 'Chart of Accounts',
  journals: 'Manual Journals',
  periods: 'Accounting Periods',
  reports: 'Reports',
  migration: 'Data Migration',
  settings: 'Settings',
};
